import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import { isMobile } from '../../../screenUtils';
import AddCoworkersInput from '../AddCoworkersInput';
import './SelectOrInviteNewCoworkers.scss';
var createMemberSelectOption = function createMemberSelectOption(member) {
  var label;
  if (member.name) {
    label = member.name;
  } else {
    label = member.email;
  }
  return {
    value: member.email,
    label: label
  };
};
function Menu(props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement(components.Menu, props, children, /*#__PURE__*/React.createElement("hr", {
    className: "mb-0 mt-0"
  }), /*#__PURE__*/React.createElement("div", {
    className: "invite-new-colleague-container body-text-2 me-3 py-3"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-envelope green"
  }), /*#__PURE__*/React.createElement("span", {
    className: "me-3"
  }, /*#__PURE__*/React.createElement("a", {
    role: "button",
    tabIndex: -1,
    className: "invite-new-colleague-link medium-weight",
    onClick: function onClick() {
      return props.selectProps.onClickInvite();
    }
  }, "Invite a new colleague by email"))));
}
var SelectOrInviteNewCoworkers = /*#__PURE__*/function (_Component) {
  function SelectOrInviteNewCoworkers(props) {
    var _this;
    _classCallCheck(this, SelectOrInviteNewCoworkers);
    _this = _callSuper(this, SelectOrInviteNewCoworkers, [props]);
    _this.invitableOptionsForSelect = _this.createInvitableOptionsForSelect();
    _this.state = {
      showInvite: isMobile() || _this.invitableOptionsForSelect.length === 0,
      showMenu: false
    };

    // solely used so we can manually remove focus from the dropdown
    _this.selectRef = /*#__PURE__*/React.createRef();
    _this.handleClickedInviteNew = _this.handleClickedInviteNew.bind(_this);
    _this.setShowMenu = _this.setShowMenu.bind(_this);
    return _this;
  }
  _inherits(SelectOrInviteNewCoworkers, _Component);
  return _createClass(SelectOrInviteNewCoworkers, [{
    key: "setShowMenu",
    value: function setShowMenu(show) {
      this.setState({
        showMenu: show
      });
    }
  }, {
    key: "handleClickedInviteNew",
    value: function handleClickedInviteNew() {
      this.setState({
        showInvite: true,
        showMenu: false
      });
      this.selectRef.current.blur();
    }
  }, {
    key: "createInvitableOptionsForSelect",
    value: function createInvitableOptionsForSelect() {
      var _this$props = this.props,
        allCoworkers = _this$props.allCoworkers,
        excluded = _this$props.excluded;

      // pruning current user, reps, and those who are excluded
      var teamMembers = allCoworkers.team_members.filter(function (member) {
        return !member.is_rep && !excluded.includes(member.name) && !excluded.includes(member.email);
      });
      return teamMembers.map(function (member) {
        return createMemberSelectOption(member);
      });
    }
  }, {
    key: "renderInviteNewColleagues",
    value: function renderInviteNewColleagues() {
      var showInvite = this.state.showInvite;
      if (!showInvite) {
        return null;
      }
      var _this$props2 = this.props,
        newCoworkers = _this$props2.newCoworkers,
        onChangeNewCoworkers = _this$props2.onChangeNewCoworkers,
        invitableRoles = _this$props2.invitableRoles,
        selectedInvitationRole = _this$props2.selectedInvitationRole,
        onChangeNewCoworkersRole = _this$props2.onChangeNewCoworkersRole;
      return /*#__PURE__*/React.createElement(AddCoworkersInput, {
        emails: newCoworkers,
        onChangeEmails: onChangeNewCoworkers,
        invitableRoles: invitableRoles,
        selectedRole: selectedInvitationRole,
        onChangeSelectedRole: onChangeNewCoworkersRole,
        withMessage: false
      });
    }
  }, {
    key: "renderSelectColleagues",
    value: function renderSelectColleagues() {
      var _this2 = this;
      if (this.invitableOptionsForSelect.length === 0) {
        return null;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "select-container mb-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "select-header medium-weight body-text-2 mb-2"
      }, "Select coworkers"), /*#__PURE__*/React.createElement("div", {
        className: "select-component-wrapper"
      }, /*#__PURE__*/React.createElement(Select, {
        ref: this.selectRef,
        menuIsOpen: this.state.showMenu,
        isMulti: true,
        maxMenuHeight: 170,
        options: this.invitableOptionsForSelect,
        classNamePrefix: "coworkers-select",
        onChange: function onChange(newSelection) {
          return _this2.props.onChangeExistingCoworkers(newSelection);
        },
        value: this.props.selectedCoworkers,
        components: {
          Menu: Menu
        },
        closeMenuOnSelect: false,
        onMenuOpen: function onMenuOpen() {
          return _this2.setShowMenu(true);
        },
        onMenuClose: function onMenuClose() {
          return _this2.setShowMenu(false);
        },
        onClickInvite: this.handleClickedInviteNew
      })));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "select-invite-container"
      }, this.renderSelectColleagues(), this.renderInviteNewColleagues());
    }
  }]);
}(Component);
SelectOrInviteNewCoworkers.propTypes = {
  invitableRoles: PropTypes.arrayOf(PropTypes.string),
  allCoworkers: PropTypes.shape({
    current_user_permission: PropTypes.shape({}),
    team_members: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  onChangeExistingCoworkers: PropTypes.func.isRequired,
  onChangeNewCoworkers: PropTypes.func.isRequired,
  onChangeNewCoworkersRole: PropTypes.func.isRequired,
  selectedCoworkers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  newCoworkers: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedInvitationRole: PropTypes.string.isRequired,
  excluded: PropTypes.arrayOf(PropTypes.string)
};
SelectOrInviteNewCoworkers.defaultProps = {
  excluded: []
};
export default SelectOrInviteNewCoworkers;